
























import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import * as types from "@/store/constants/ins_user_info_types";
import UserOneItem from "./UserItem/UserOneItem.vue";
import UserMoreItem from "./UserItem/UserMoreItem.vue";
import ManageEntrance from "./ManageEntrance/ManageEntrance.vue";
import EmptyAccountPalce from "@/components/EmptyAccountPalce/EmptyAccountPalce.vue";
import { isIos } from "@/utils/lodash";
@Component({
  components: { EmptyAccountPalce, UserOneItem, UserMoreItem, ManageEntrance }
})
export default class MoreUserInfo extends Vue {
  @Getter(types.GETTER_INS_USER_INFO_LIST)
  private userInfoList: any;

  get isIOS() {
    return isIos();
  }

  private clickMore() {
    this.$emit("click");
  }
}
